import { defineComponent as r, openBlock as a, createBlock as n, unref as p, mergeProps as l, withCtx as m, createElementVNode as v } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconLaptopCamera",
  __name: "IconLaptopCamera",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (a(), n(p(c), l(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        v("path", {
          "fill-rule": "evenodd",
          d: "M5 6.25A2.25 2.25 0 0 0 2.75 8.5v7A2.25 2.25 0 0 0 5 17.75h9a2.25 2.25 0 0 0 2.25-2.25v-.175l3.107 1.864a1.25 1.25 0 0 0 1.893-1.072V7.883a1.25 1.25 0 0 0-1.893-1.072L16.25 8.675V8.5A2.25 2.25 0 0 0 14 6.25H5m11.25 4.175v3.15l3.5 2.1v-7.35l-3.5 2.1M14.75 8.5A.75.75 0 0 0 14 7.75H5A.75.75 0 0 0 4.25 8.5v7A.75.75 0 0 0 5 16.25h9a.75.75 0 0 0 .75-.75v-7",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
